<div class="data-view-modal">
  <!-- Header -->
  <div class="modal-header">
   <h5 class="modal-title">
      <i class="fas fa-table me-2"></i>
      {{ data.deviceData?.name || 'Device' }} - Data View
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="onClose()" aria-label="Close"></button>
  </div>

  <!-- Info Banner -->
  <div class="info-banner">
    <div class="info-group d-flex align-items-center flex-wrap">
    <div class="info-item me-2">
      <i class="fas fa-database me-1"></i>
      <strong>Total Records:</strong> {{ rowData.length }}
    </div>
    <div class="info-item me-3">
      <i class="fas fa-microchip me-1"></i>
      <strong>Device:</strong>
      <span class="device-value" [title]="data.deviceData?.deviceNumber || 'N/A'">{{ data.deviceData?.deviceNumber || 'N/A' }}</span>
    </div>

    <!-- Date Range -->
    <div class="date-range d-flex align-items-center flex-wrap">
      <mat-label class="me-2 text-nowrap">Date Range :</mat-label>
      <button type="button" class="btn btn-outline-primary btn-sm me-2" (click)="navigatePrevious()"
        [disabled]="isLoading" title="Previous">
        <i class="fas fa-chevron-left"></i>
      </button>
      <mat-form-field class="data-range-input" appearance="outline" subscriptSizing="dynamic">
        <input matInput [matDatepicker]="fromPicker" placeholder="From date" [(ngModel)]="selectedDateRange.start"
          [max]="selectedDateRange.end" [disabled]="isLoading" (dateChange)="onDateRangeChange()" />
        <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>
      <span class="mx-2">to</span>
      <mat-form-field class="data-range-input" appearance="outline" subscriptSizing="dynamic">
        <input matInput [matDatepicker]="toPicker" placeholder="To date" [(ngModel)]="selectedDateRange.end"
          [min]="selectedDateRange.start" [disabled]="isLoading" (dateChange)="onDateRangeChange()" />
        <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
      <button type="button" class="btn btn-outline-primary btn-sm ms-2" (click)="navigateNext()"
        [disabled]="isLoading" title="Next">
        <i class="fas fa-chevron-right"></i>
      </button>

      <!-- Granularity -->
      <mat-radio-group class="range-radio-group ms-3" [(ngModel)]="selectedRange" [disabled]="isLoading"
        (change)="onRangeChange()">
        <mat-radio-button value="day" class="range-radio">Day</mat-radio-button>
        <mat-radio-button value="week" class="range-radio">Week</mat-radio-button>
        <mat-radio-button value="month" class="range-radio">Month</mat-radio-button>
        <mat-radio-button value="year" class="range-radio">Year</mat-radio-button>
      </mat-radio-group>
    </div>
    </div>
     <button type="button" class="btn btn-primary btn-sm" (click)="downloadCSV()">
        <i class="fas fa-download"></i>
        Download CSV
      </button>

  </div>

  <!-- AG Grid -->
  <div class="modal-body">
    <div class="ag-theme-alpine">
      <ag-grid-angular
        #agGrid
        class="grid-container"
        [columnDefs]="columnDefs"
        [rowData]="rowData"
        [defaultColDef]="defaultColDef"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)">
      </ag-grid-angular>
    </div>

    <!-- Loader overlay shown while re-fetching data (previous/next/range change) -->
    <div class="data-view-loader" *ngIf="isLoading">
      <div class="spinner"></div>
    </div>
  </div>
</div>
